import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoLink from 'eco-design/base/eco-link';
import IndexClient from './index.client';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const prefixCls = 'index-user-story-2';
    const { title, titleColor, bgColor, linkText, linkURL, list } = data;

    return (
        <GloLayout
            className={`editor-${prefixCls} editor-${prefixCls}-${id}`}
            id={id}
            data={data}
            floorName={`${prefixCls}`}
            style={
                {
                    '--title-color': titleColor,
                    '--bg-color': bgColor,
                } as React.CSSProperties
            }
        >
            <div className={`${prefixCls}-header`}>
                <h2 className={`${prefixCls}-header-title`}>{title}</h2>
                {linkText && linkURL && (
                    <EcoLink className={`${prefixCls}-link`} href={linkURL}>
                        <span>{linkText}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </EcoLink>
                )}
            </div>
            <IndexClient list={list} prefixCls={prefixCls} id={id} />
        </GloLayout>
    );
}
